import { api, ApiError } from '../../api/client';
import { API_BASE_URL } from '../../config/api';
import { extractCouponsArray, normalizeCoupon } from './cartCouponUtils';

/**
 * @param {string} token Bearer access token
 * @returns {Promise<{ message: string, coupons: import('./cartCouponUtils').NormalizedCoupon[] }>}
 */
export async function fetchActiveCoupons(token) {
  const { data } = await api.get(`${API_BASE_URL}/discounts/activeCoupons`, {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    timeoutMs: 20000,
  });

  const rawList = extractCouponsArray(data);
  const coupons = rawList
    .map((row) => normalizeCoupon(row))
    .filter((c) => c != null);

  const message =
    data && typeof data === 'object' && typeof data.message === 'string'
      ? data.message
      : '';

  return { message, coupons };
}

export { ApiError };
